import PropTypes from "prop-types"

const LayoutStyled = {
  display: "flex",
  justifyContent: "center",
  maxWidth: "1300px",
  margin: "auto",
  paddingBottom: "0px",
}
const LayoutCommon = props => {
  const { style } = props
  return (
    <div
      style={{
        ...LayoutStyled,
        maxWidth: props?.isAdmin ? "initial" : "1300px",
        ...style,
      }}
    >
      <div style={{ width: "100%" }} {...props}>
        {props?.children}
      </div>
    </div>
  )
}

export default LayoutCommon

LayoutCommon.propTypes = {
  style: PropTypes.object,
}
